import { FC } from 'react';
import { LogIn } from 'lucide-react';
import styled from 'styled-components';

import { PremierText } from '@components/text';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const Container = styled(TouchableOpacity)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

const Icon = styled(LogIn)`
  width: 28px;
  height: 28px;
  color: ${({ theme }) => theme.colors.red[500]};
  transform: rotate(180deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 20px;
    height: 20px;
  }
`;

const Text = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.lg};
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fonts.fontSize.base};
  }
`;

type Props = {
  text: string;
  onExitShow: () => void;
};

const ExitButton: FC<Props> = ({ text, onExitShow }) => {
  return (
    <Container onClick={onExitShow}>
      <Icon />

      <Text>{text}</Text>
    </Container>
  );
};

export default ExitButton;
